import React from "react";
import { Link } from "react-router-dom";
import { User } from "lucide-react";
import { usePatientMode } from "@/lib/patientMode";
import { ThemeToggle } from "@/components/ThemeToggle";
import { FullscreenToggle, useFullscreen } from "@/components/FullscreenToggle";

export const Brand = ({ compact = false }) => (
  <div className="flex flex-col items-center text-center select-none">
    <div
      className={`font-serif-title tracking-[0.35em] text-[var(--gold)] ${compact ? "text-xl sm:text-3xl" : "text-2xl sm:text-4xl"}`}
      style={{ fontWeight: 600, fontVariantNumeric: "lining-nums" }}
      data-testid="brand-title"
    >
      M2HAT PSYCHOLOGIE
    </div>
    <div
      className={`mt-1.5 text-[var(--ink-soft)] uppercase ${compact ? "text-[0.7rem] sm:text-xs" : "text-xs sm:text-sm"}`}
      style={{ letterSpacing: "0.22em" }}
    >
      Bilan cognitif · Évaluation et suivi thérapeutique
    </div>
    <div className="mt-3 sm:mt-4 h-px w-16 sm:w-20 bg-[var(--gold-light)]" />
  </div>
);

export const Layout = ({ children, header = true, wide = false, className = "" }) => {
  const { patientMode, patientName } = usePatientMode();
  const { immersive } = useFullscreen();
  const mw = wide ? "max-w-6xl" : "max-w-3xl";
  return (
    <div className={`min-h-screen w-full bg-[var(--cream)] flex flex-col items-center px-4 overflow-x-clip ${immersive ? "py-4" : "py-5 sm:py-12"} ${className}`}>
      {immersive && <div className="fixed bottom-4 right-4 z-50 no-print drop-shadow-md" data-testid="fullscreen-exit-floating"><FullscreenToggle /></div>}
      {header && !immersive && (
        <header className={`w-full ${mw} mb-5 sm:mb-8 no-print relative flex flex-col items-center`}>
          <div className="self-end mb-2 flex items-center gap-2 sm:absolute sm:right-0 sm:top-0 sm:mb-0"><FullscreenToggle /><ThemeToggle /></div>
          <Link
            to="/"
            aria-label="Retour à l'accueil"
            className="inline-block rounded-lg transition-opacity hover:opacity-75 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold)]"
            data-testid="brand-home-link"
          >
            <Brand compact />
          </Link>
        </header>
      )}
      {patientMode && patientName && !immersive && (
        <div className={`w-full ${mw} mb-6`} data-testid="patient-banner">
          <div className="flex items-center gap-2 rounded-2xl bg-[var(--sand)] border border-[var(--border)] px-4 py-2.5 text-sm text-[var(--ink)]">
            <User size={15} className="text-[var(--gold)]" />
            <span>Passation pour&nbsp;: <strong className="text-[var(--gold)]">{patientName}</strong></span>
          </div>
        </div>
      )}
      <main className={`w-full ${mw}`}>{children}</main>
    </div>
  );
};
